import { IPasteSpecialServiceDelegates } from '@src/slide/application/service/copy-paste/core/paste/paste-special/paste-special-strategy/interface';
import { IPcCopyPaste } from '@src/slide/application/service/copy-paste/core/pc/pc-copy-paste.interface';
import EditingStateManager from '@src/slide/application/service/editing-state-manager';
import { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { IUndoRedoService } from '@src/slide/application/service/undo-redo-service/undo-redo-service.interface';
import { ICopyInfo } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
export enum PasteSpecialType {
    DESTINATION_THEME = 'destination_theme',
    SOURCE_FORMAT = 'source_format',
    TEXT_ONLY = 'text_only',
    PICTURE = 'picture',
}

export interface IPasteSpecialProps {
    position: { left: number; top: number };
    copyInfo: ICopyInfo;
    serviceDelegates: IPasteSpecialServiceDelegates;
    beforePaste?: () => void;
    afterPaste?: () => void;
}


export interface ISlidePasteProps {
    slideHeight: number;
    sectionWidth: number;
    slideNum: number;
    sectionNum: number;
}

export interface IEditorPasteProps {
    canvasTop: number;
    canvasLeft: number;
    scale: number;
    serviceDelegates: {
        uiDataService: IUiDataService;
        selectionService: ISelectionService;
        editingStateManager: EditingStateManager;
        masterLayoutEditService?: IMasterLayoutEditService;
        undoRedoService?: IUndoRedoService;
        copyPasteManager?: IDynamicService<IPcCopyPaste>;
    }
}

export interface IMenuProps {
    showTextOnlyOption?: boolean;
    onMenuClick: (menuId: PasteSpecialType) => void;
}

export type Off = () => void;

export interface ISectionNum {
    sectionNum: number;
    slideNum: number;
}

export enum PanelType {
    SLIDE_PASTE_PANEL = 'showSlidePastePanel',
    EDIT_PASTE_PANEL = 'showEditorPastePanel',
    TEXT_PASTE_PANEL = 'showTextPastePanel',
}
